<template>
  <div>
    <v-data-table
      :headers="columns"
      :items="tableData"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-options': [10, 50, 100]
      }"
      :options.sync="options"
      class="elevation-1"
    >
      <template v-for="(col, i) in filters" v-slot:[`header.${i}`]="{ header }">
        <div style="display: inline-block; padding: 16px 0;" v-bind:key="i">
          <span>{{ header.text }}</span>
        </div>
        <div style="float: right; margin-top: 8px" v-bind:key="`A` + i">
          <v-menu
            :close-on-content-click="false"
            :nudge-width="200"
            offset-y
            transition="slide-y-transition"
            left
            fixed
            style="position: absolute; right: 0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="indigo" icon v-bind="attrs" v-on="on">
                <v-icon
                  small
                  :color="
                    activeFilters[header.value] &&
                    activeFilters[header.value].length <
                      filters[header.value].length
                      ? 'red'
                      : 'default'
                  "
                >
                  mdi-filter-variant
                </v-icon>
              </v-btn>
            </template>
            <v-list flat dense class="pa-0">
              <v-list-item-group
                multiple
                v-model="activeFilters[header.value]"
                class="py-2"
              >
                <div class="search_input">
                  <v-text-field
                    hide-details
                    v-model="searchString[header.value]"
                    placeholder="Search ..."
                    class="pl-2 pr-2"
                    @input="searchItem(header.value)"
                  ></v-text-field>
                </div>
                <template v-for="(item, j) in filters[header.value]">
                  <v-list-item
                    v-bind:key="`A${j}`"
                    :value="item"
                    :ripple="false"
                  >
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          :true-value="item"
                          @click="toggle"
                          color="primary"
                          :ripple="false"
                          dense
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title v-text="item"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
              <v-row no-gutters>
                <v-col cols="6">
                  <v-btn
                    text
                    block
                    @click="toggleAll(header.value)"
                    color="success"
                    >{{ $t("toggleall") }}</v-btn
                  >
                </v-col>
                <v-col cols="6">
                  <v-btn
                    text
                    block
                    @click="clearAll(header.value)"
                    color="warning"
                    >{{ $t("clearall") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-list>
          </v-menu>
        </div>
      </template>
      <template v-slot:item.productType="{ item }">
        <v-autocomplete
          v-model="editedItem.productType"
          :items="product_types"
          filled
          :hide-details="true"
          dense
          v-if="item.id === editedItem.id"
        ></v-autocomplete>
        <span v-else>{{ item.productType }}</span>
      </template>
      <template v-slot:item.status="{ item }">
        <v-autocomplete
          v-model="editedItem.status"
          :items="user_status"
          filled
          :hide-details="true"
          dense
          v-if="item.id === editedItem.id"
        ></v-autocomplete>
        <span v-else>{{ item.status }}</span>
      </template>
      <template v-slot:item.returns_accepted="{ item }">
        <v-autocomplete
          v-model="editedItem.returns_accepted"
          :items="yn_types"
          filled
          :hide-details="true"
          dense
          v-if="item.id === editedItem.id"
        ></v-autocomplete>
        <span v-else>{{ item.returns_accepted }}</span>
      </template>
      <template v-slot:item.priority_1="{ item }">
        <v-autocomplete
          v-model="editedItem.priority_1"
          :items="yn_types"
          filled
          :hide-details="true"
          dense
          v-if="item.id === editedItem.id"
        ></v-autocomplete>
        <span v-else>{{ item.priority_1 }}</span>
      </template>
      <template v-slot:item.priority_2="{ item }">
        <v-autocomplete
          v-model="editedItem.priority_2"
          :items="yn_types"
          filled
          :hide-details="true"
          dense
          v-if="item.id === editedItem.id"
        ></v-autocomplete>
        <span v-else>{{ item.priority_2 }}</span>
      </template>
      <template v-slot:item.novelty="{ item }">
        <v-autocomplete
          v-model="editedItem.novelty"
          :items="yn_types"
          filled
          :hide-details="true"
          dense
          v-if="item.id === editedItem.id"
        ></v-autocomplete>
        <span v-else>{{ item.novelty }}</span>
      </template>
      <template v-slot:item.outOfStock="{ item }">
        <v-autocomplete
          v-model="editedItem.outOfStock"
          :items="outOfStockTypes"
          item-text="label"
          item-value="value"
          filled
          :hide-details="true"
          dense
          v-if="item.id === editedItem.id"
        ></v-autocomplete>
        <span v-else>{{ item.outOfStock }}</span>
      </template>
      <template v-slot:item.id_product_operator="{ item }">
        <v-text-field
          v-model="editedItem.id_product_operator"
          :hide-details="true"
          filled
          dense
          v-if="item.id === editedItem.id"
        >
        </v-text-field>
        <span v-else>{{ item.id_product_operator }}</span>
      </template>
      <template v-slot:item.unit_price_without_vat="{ item }">
        <v-text-field
          v-model="editedItem.unit_price_without_vat"
          :type="'number'"
          :hide-details="true"
          filled
          dense
          v-if="item.id === editedItem.id"
        >
        </v-text-field>
        <span v-else>{{ item.unit_price_without_vat }}</span>
      </template>
      <template v-slot:item.returns_max="{ item }">
        <v-text-field
          v-model="editedItem.returns_max"
          type="number"
          :hide-details="true"
          filled
          dense
          v-if="item.id === editedItem.id"
        >
        </v-text-field>
        <span v-else>{{ item.returns_max }}</span>
      </template>
      <template v-slot:item.priority_label="{ item }">
        <v-text-field
          v-model="editedItem.priority_label"
          :type="'number'"
          :hide-details="true"
          filled
          dense
          v-if="item.id === editedItem.id"
        >
        </v-text-field>
        <span v-else>{{ item.priority_label }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <div v-if="item.id === editedItem.id">
          <v-icon color="red" class="mr-3" @click="close">
            mdi-window-close
          </v-icon>
          <v-icon color="green" @click="save">
            mdi-content-save
          </v-icon>
        </div>
        <div v-else>
          <v-icon color="green" class="mr-3" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon color="red" class="mr-3" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";
import _ from "lodash";

export default {
  name: "veTableSubProducts",
  props: ["row", "assortmentDetail", "update_table"],
  data: function() {
    return {
      current_rows: null,
      tableData: [],
      tempdata: [],
      options: {},
      loading: false,
      filterCriteria: {},
      user_status: ["active", "inactive"],
      yn_types: ["Yes", "No"],
      outOfStockTypes: [
        { label: "Yes", value: "YES" },
        { label: "No", value: "NO" }
      ],
      product_types: ["ONLYSURVEY", "ONLYSALES", "BOTH"],
      filters: {
        name: [],
        productType: [],
        status: [],
        id_product_operator: [],
        unit_price_without_vat: [],
        returns_accepted: [],
        returns_max: [],
        outOfStock: [],
        priority_label: [],
        priority_1: [],
        priority_2: [],
        novelty: []
      },
      initFilterList: {
        name: [],
        productType: [],
        status: [],
        id_product_operator: [],
        unit_price_without_vat: [],
        returns_accepted: [],
        returns_max: [],
        outOfStock: [],
        priority_label: [],
        priority_1: [],
        priority_2: [],
        novelty: []
      },
      searchString: {
        name: "",
        productType: "",
        status: "",
        id_product_operator: "",
        unit_price_without_vat: "",
        returns_accepted: "",
        returns_max: "",
        outOfStock: "",
        priority_label: "",
        priority_1: "",
        priority_2: "",
        novelty: ""
      },
      activeFilters: {},

      editedIndex: -1,
      editedItem: {
        id: 0,
        productType: "ONLYSALES",
        status: "active",
        id_product_operator: "",
        unit_price_without_vat: "",
        returns_accepted: "Yes",
        returns_max: "",
        outOfStock: "YES",
        priority_label: "",
        priority_1: "Yes",
        priority_2: "Yes",
        novelty: "Yes"
      },
      defaultItem: {
        id: 0,
        productType: "ONLYSALES",
        status: "active",
        id_product_operator: "",
        unit_price_without_vat: "",
        returns_accepted: "Yes",
        returns_max: "",
        outOfStock: "YES",
        priority_label: "",
        priority_1: "Yes",
        priority_2: "Yes",
        novelty: "Yes"
      }
    };
  },
  watch: {
    async row(newVal, oldVal) {
      if (newVal) {
        this.init(newVal);
      }
    },
    options: {
      handler() {
        this.sortChange();
      },
      deep: true
    }
  },
  computed: {
    columns() {
      return [
        {
          text: "ID",
          value: "id",
          width: "100px"
        },
        {
          text: this.$t("Product") + " " + this.$t("brands.name"),
          value: "name",
          width: "300px",
          filter: value => {
            return this.activeFilters.name
              ? this.activeFilters.name.includes(value)
              : true;
          }
        },
        {
          text: "Tipo de producto",
          value: "productType",
          width: "250px",
          filter: value => {
            return this.activeFilters.productType
              ? this.activeFilters.productType.includes(value)
              : true;
          }
        },
        {
          text: this.$t("salesforce.status"),
          value: "status",
          width: "150px",
          filter: value => {
            return this.activeFilters.status
              ? this.activeFilters.status.includes(value)
              : true;
          }
        },
        {
          text: this.$t("brands.id_product_operator"),
          value: "id_product_operator",
          width: "300px",
          filter: value => {
            return this.activeFilters.id_product_operator
              ? this.activeFilters.id_product_operator.includes(value)
              : true;
          }
        },
        {
          text: this.$t("brands.unit_price_without_vat"),
          value: "unit_price_without_vat",
          width: "250px",
          filter: value => {
            return this.activeFilters.unit_price_without_vat
              ? this.activeFilters.unit_price_without_vat.includes(value)
              : true;
          }
        },
        {
          text: this.$t("brands.returns_accepted"),
          value: "returns_accepted",
          width: "270px",
          filter: value => {
            return this.activeFilters.returns_accepted
              ? this.activeFilters.returns_accepted.includes(value)
              : true;
          }
        },
        {
          text: this.$t("brands.returns_max"),
          value: "returns_max",
          width: "270px",
          filter: value => {
            return this.activeFilters.returns_max
              ? this.activeFilters.returns_max.includes(value)
              : true;
          }
        },
        {
          text: this.$t("Out of Stock"),
          value: "outOfStock",
          width: "270px",
          filter: value => {
            return this.activeFilters.outOfStock
              ? this.activeFilters.outOfStock.includes(value)
              : true;
          }
        },
        {
          text: this.$t("brands.priority_label"),
          value: "priority_label",
          width: "200px",
          filter: value => {
            return this.activeFilters.priority_label
              ? this.activeFilters.priority_label.includes(value)
              : true;
          }
        },
        {
          text: this.$t("brands.priority_1"),
          value: "priority_1",
          width: "200px",
          filter: value => {
            return this.activeFilters.priority_1
              ? this.activeFilters.priority_1.includes(value)
              : true;
          }
        },
        {
          text: this.$t("brands.priority_2"),
          value: "priority_2",
          width: "200px",
          filter: value => {
            return this.activeFilters.priority_2
              ? this.activeFilters.priority_2.includes(value)
              : true;
          }
        },
        {
          text: this.$t("brands.novelty"),
          value: "novelty",
          width: "200px",
          filter: value => {
            return this.activeFilters.novelty
              ? this.activeFilters.novelty.includes(value)
              : true;
          }
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "120px"
        }
      ];
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },
    async deleteItem(item) {
      if (window.confirm(this.$t("confirmdelete"))) {
        const { assortmentId, productId } = item.assortment_product;
        try {
          await ApiService.delete(
            `assortment/deleteproduct/${assortmentId}/${productId}`
          );
          logInfo("Éxito !");
          await this.update_table();
          this.close();
        } catch (error) {
          logError("Error occured !");
        }
      }
    },
    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    async save() {
      if (this.editedIndex > -1) {
        const { assortmentId, productId } = this.editedItem.assortment_product;
        const {
          productType,
          id_product_operator,
          unit_price_without_vat,
          returns_accepted,
          returns_max,
          outOfStock,
          priority_label,
          priority_1,
          priority_2,
          novelty,
          status
        } = this.editedItem;
        let postData = {
          productType,
          id_product_operator,
          unit_price_without_vat,
          returns_accepted,
          returns_max,
          outOfStock,
          priority_label,
          priority_1,
          priority_2,
          novelty,
          status
        };
        console.log(this.editedIndex, postData);
        try {
          await ApiService.post(
            `assortment/update_assortment_product/${assortmentId}/${productId}`,
            postData
          );
          logInfo("Éxito !");
          await this.update_table();
          this.close();
        } catch (error) {
          logError("Error occured !");
        }
      }
    },
    initFilters() {
      let keys = Object.keys(this.initFilterList);
      for (const key of keys) {
        this.searchString[key] = "";
        this.initFilterList[key] = this.tableData
          .map(d => {
            return d[key];
          })
          .filter((value, index, self) => {
            return self.indexOf(value) === index;
          });
      }
      this.filters = Object.assign({}, this.initFilterList);
      this.activeFilters = Object.assign({}, this.filters);
    },
    searchItem(col) {
      this.changeStr(col, this.searchString[col]);
    },
    changeStr(col, search_str) {
      if (search_str) {
        this.filters[col] = this.initFilterList[col].filter(item =>
          item.toLowerCase().includes(search_str.toLowerCase())
        );
      } else {
        this.filters[col] = this.initFilterList[col];
      }
      this.activeFilters = Object.assign({}, this.filters);
    },
    toggleAll(col) {
      this.activeFilters[col] = this.tableData
        .map(d => {
          return d[col];
        })
        .filter((value, index, self) => {
          return self.indexOf(value) === index;
        });
      this.searchString[col] = null;
      this.changeStr(col, null);
    },
    clearAll(col) {
      this.activeFilters[col] = [];
    },
    sortChange() {
      let { sortBy, sortDesc } = this.options;
      if (sortBy && sortBy.length > 0) {
        sortBy = sortBy[0];
        sortDesc = sortDesc[0];
        if (sortDesc) {
          this.tempdata = _.sortBy(this.tempdata, sortBy).reverse();
        } else {
          this.tempdata = _.sortBy(this.tempdata, sortBy);
        }
        this.tableData = this.tempdata;
      }
    },
    init(newVal) {
      this.current_rows = newVal;
      this.current_rows = this.current_rows.map(item => {
        let push_item = { ...item };
        if (push_item?.assortment_product) {
          const {
            productType,
            id_product_operator,
            unit_price_without_vat,
            returns_accepted,
            returns_max,
            outOfStock,
            priority_label,
            priority_1,
            priority_2,
            novelty,
            status
          } = push_item?.assortment_product;
          push_item["status"] = status;
          push_item["productType"] = productType;
          push_item["id_product_operator"] = id_product_operator;
          push_item["unit_price_without_vat"] = unit_price_without_vat;
          push_item["returns_accepted"] = returns_accepted;
          push_item["returns_max"] = returns_max;
          push_item["outOfStock"] = outOfStock;
          push_item["priority_label"] = priority_label;
          push_item["priority_1"] = priority_1;
          push_item["priority_2"] = priority_2;
          push_item["novelty"] = novelty;
        }
        return push_item;
      });
      this.tableData = this.current_rows;
      this.tempdata = this.current_rows;
      this.initFilters();
    }
  },
  async updated() {},
  async mounted() {
    this.init(this.row);
  }
};
</script>

<style>
.v-list--dense .v-list-item,
.v-list-item--dense {
  min-height: 20px !important;
  height: 2rem;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 0.5rem !important;
}

.v-list-item--link {
  transition: background-color 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.v-list-item--link:hover {
  background-color: rgba(0, 0, 0, 0.13);
}
</style>
